// Shared motion variants & helpers for landing sections.
// Keep all animations subtle, short, Apple-quiet.

export const fadeUp = {
  initial: { opacity: 0, y: 12 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-80px' },
  transition: { duration: 0.55, ease: [0.16, 1, 0.3, 1] },
};

export const fadeIn = {
  initial: { opacity: 0 },
  whileInView: { opacity: 1 },
  viewport: { once: true, margin: '-60px' },
  transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] },
};

export const stagger = (delay = 0.08) => ({
  transition: { staggerChildren: delay, delayChildren: 0.1 },
});

// Apple-style section wrapper classes (generous breathing room).
export const sectionWrap = 'relative border-t border-border/60';
export const sectionInner = 'mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8 py-16 sm:py-20 lg:py-24';

// Type scale tokens used across the page.
export const displayHero = 'font-display font-semibold tracking-[-0.045em] leading-[0.98] text-foreground';
export const displaySection = 'font-display font-semibold tracking-[-0.04em] leading-[1.02] text-foreground';
export const kicker = "text-[11px] font-mono-edge font-medium tracking-[0.28em] uppercase text-primary";
export const eyebrowMuted = "text-[11px] font-mono-edge font-medium tracking-[0.28em] uppercase text-muted-foreground";
export const lead = 'text-base sm:text-lg text-muted-foreground leading-relaxed';
